/* Общие подписи раздела «Сотрудники»: как называть тип оплаты, единицу
   учёта и отметку дня. В одном месте — чтобы табель, ведомость, листок и
   карточка говорили одними словами. */

export const MONTHS = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

export const WEEKDAYS = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

const nf = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 });
const rub = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });

export const num = (v) => nf.format(Number(v) || 0);
export const money = (v) => `${rub.format(Math.round(Number(v) || 0))} ₽`;
/* В плотной сетке знак рубля у каждой цифры — шум; он стоит в шапке колонки. */
export const amount = (v) => (Number(v) ? rub.format(Math.round(Number(v))) : '—');

export const plural = (n, one, few, many) => {
  const m10 = Math.abs(n) % 10;
  const m100 = Math.abs(n) % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
  return many;
};

export const PAY_TYPES = [
  { value: 'hourly', label: 'Почасовая', rateLabel: 'Ставка за час, ₽' },
  { value: 'shift', label: 'Посменная', rateLabel: 'Ставка за смену, ₽' },
  { value: 'salary', label: 'Оклад', rateLabel: 'Оклад в месяц, ₽' },
];

export const rateLabel = (payType, rate) => {
  if (payType === 'percent') return 'процент';
  if (!rate) return 'ставка не задана';
  if (payType === 'salary') return `оклад ${money(rate)}`;
  if (payType === 'shift') return `${money(rate)} за смену`;
  return `${money(rate)} в час`;
};

/* Что считается в колонке «часы» у этой строки. */
export const unitOf = (payType, n) => {
  if (payType === 'shift') return n === undefined ? 'смен' : plural(Math.round(n), 'смена', 'смены', 'смен');
  if (payType === 'salary') return n === undefined ? 'дней' : plural(Math.round(n), 'день', 'дня', 'дней');
  return 'ч';
};

/* Отметки дня — те же буквы, что в Excel-табеле. */
export const DAY_CODES = {
  dayoff: 'в', vacation: 'отп', sick: 'б', closed: 'н/р', idle: 'п/р', training: 'ст', off: 'ув',
};
export const DAY_TITLES = {
  dayoff: 'Выходной', vacation: 'Отпуск', sick: 'Больничный', closed: 'Не работали', idle: 'Простой',
  training: 'Стажировка', off: 'Не в штате', other: 'Отметка',
};

export const cellText = (cell) => {
  if (!cell) return '';
  if (cell.day_type === 'work') return cell.hours ? num(cell.hours) : '';
  return cell.mark || DAY_CODES[cell.day_type] || '';
};

export const shiftMonth = ({ year, month }, delta) => {
  const m = month - 1 + delta;
  return { year: year + Math.floor(m / 12), month: ((m % 12) + 12) % 12 + 1 };
};

export const monthLabel = ({ year, month }) => `${MONTHS[month - 1]} ${year}`;

/* Сервер отдаёт closed_days с ключами-строками (JSON), иногда числами. */
export const closedNote = (period, day) => {
  const days = period?.closed_days || {};
  if (Object.prototype.hasOwnProperty.call(days, day)) return days[day];
  if (Object.prototype.hasOwnProperty.call(days, String(day))) return days[String(day)];
  return null;
};
